import { create } from 'zustand';
import { createTripBookingSlice, type TripBookingSlice } from './slice';

/**
 * Standalone trip booking store
 * Not integrated with the main app store for now
 */
export const useTripBookingStore = create<TripBookingSlice>()(
	(set, get, api) => ({
		...createTripBookingSlice(set, get, api),
	}),
);

/**
 * Performance-optimized selectors for the trip booking slice
 * Use these instead of accessing the store directly for better performance
 */

// Trip booking data selectors
export const useTripBookingData = () =>
	useTripBookingStore((state) => state.tripBooking.bookingData);

export const useCabUpdateData = () =>
	useTripBookingStore((state) => state.tripBooking.cabUpdate);

// Trip booking actions selector
export const useTripBookingActions = () =>
	useTripBookingStore((state) => state.tripBookingActions);

export function getTripBookingState() {
	return useTripBookingStore.getState().tripBooking;
}
